import React from 'react';
export const usePromise = (x) => {
    const [stateResult, setResult] = React.useState(undefined);
    React.useEffect(() => {
        setResult(undefined);
        (async () => {
            setResult(await x);
        })();
    }, [x]);
    return stateResult;
};
export default usePromise;
